import script from "./DownloadSurveyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadSurveyButton.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadSurveyButton.vue?vue&type=style&index=0&id=194b3b12&lang=scss"

const __exports__ = script;

export default __exports__